import React from 'react'

import { Page } from 'spd-gds/components/pages'

const WelcomePage = () => {
  return (
    <Page type='welcome' className='page-welcome'>
      <div className='app-welcome'>
        <h1 className='app-welcome__title'> GDS Project </h1>
        <small className='app-welcome__subtitle'> Welcome!</small>
      </div>
    </Page>
  )
}

export default WelcomePage
